import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { GTFonts, PoppinsFonts, useTheme } from '../../../theme';
import { s, fs, v } from '../../../utils/libs';

type ExpenseInsightCardProps = {
  title: string;
  body: string;
  tone: 'info' | 'warning';
};

const TONE_CONFIG = {
  info: {
    bg: '#0596690D',
    border: '#05966933',
    dot: '#059669',
  },
  warning: {
    bg: '#FF98000D',
    border: '#FF980033',
    dot: '#FF9800',
  },
};

const ExpenseInsightCard: React.FC<ExpenseInsightCardProps> = ({
  title,
  body,
  tone,
}) => {
  const { theme } = useTheme();
  const styles = useMemo(() => createStyles(theme), [theme]);
  const toneColors = TONE_CONFIG[tone];

  return (
    <View
      style={[
        styles.container,
        {
          backgroundColor: toneColors.bg,
          borderColor: toneColors.border,
        },
      ]}>
      <View style={styles.headerRow}>
        <View
          style={[styles.dot, { backgroundColor: toneColors.dot }]}
        />
        <Text style={styles.title}>{title}</Text>
      </View>
      <Text style={styles.body}>{body}</Text>
    </View>
  );
};

export default ExpenseInsightCard;

const createStyles = (theme: any) =>
  StyleSheet.create({
    container: {
      borderRadius: theme.borderRadius.md,
      borderWidth: StyleSheet.hairlineWidth,
      padding: s(12),
      marginHorizontal: s(10),
      marginTop: v(16),
      marginBottom: v(8),
    },
    headerRow: {
      flexDirection: 'row',
      alignItems: 'center',
      columnGap: s(6),
      marginBottom: v(4),
    },
    dot: {
      width: s(6),
      height: s(6),
      borderRadius: s(3),
    },
    title: {
      fontSize: fs(13),
      fontFamily: GTFonts.bold,
      color: theme.colors.text,
    },
    body: {
      fontSize: fs(12),
      fontFamily: PoppinsFonts.regular,
      color: theme.colors.textGray500,
      lineHeight: fs(18),
    },
  });
